import { render, staticRenderFns } from "./OfficialAccountEdit.vue?vue&type=template&id=2dcbf208&scoped=true&"
import script from "./OfficialAccountEdit.vue?vue&type=script&lang=js&"
export * from "./OfficialAccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./OfficialAccountEdit.vue?vue&type=style&index=0&id=2dcbf208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbf208",
  null
  
)

export default component.exports